"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _icons = _interopRequireDefault(require("./icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    marginTop: theme.spacing(1.5),
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(1.5)
  }
}));

const PrimusPreviewIcon = ({
  className,
  icon
}) => {
  const classes = useStyles();

  if (!icon) {
    return false;
  }

  const PreviewIcon = icon && _icons.default && _icons.default[icon];
  return _react.default.createElement(PreviewIcon, {
    className: className || classes.icon
  });
};

var _default = PrimusPreviewIcon;
exports.default = _default;
module.exports = exports.default;